import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

export default Component => props => !props.isLoading ? <Component {...props} /> : <LinearProgress color="secondary" variant="query" />


